import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { store } from "~/Context/JukeboxContext";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faSadTear } from "@fortawesome/free-solid-svg-icons";

import styled from "styled-components";

export const MediaPlayTrackWrapper = styled.span`
  font-size: 16px;
  div {
    display: inline-block;
    background-color: #efefef;
    border-radius: 6px;
    overflow: auto;
    padding: 2px 14px 2px 10px;
    margin-left: 12px;
  }
  button {
    border: 0;
    padding: 7px;
    margin-right: 2px;
  }
  .play-icon {
    margin-right: 7px;
  }
  &:hover {
    cursor: pointer;
  }
  .noTrackMsg {
    text-align: left;
    font-size: 14px;
  }
  span {
    font-size: 13px;
    display: inline-block;
    white-space: nowrap;
  }
`;

const JukeboxPlayArtist = ({ artistIds = [] }) => {
  const globalState = useContext(store);
  const { dispatch } = globalState;

  const [error, setError] = useState(false);

  const playTrack = async () => {
    // await axios.get(`http://localhost:3001/playlist-artist?ids=${artistIds.join(",")}`).then(({ data }) => {
    await axios.get(`//api.dreamchimney.com/playlist-artist?ids=${artistIds.join(",")}`).then(({ data }) => {
      // @TODO fix type ?
      const playlist = (data && data[0]) || [];
      if (playlist && playlist.tracks.length) {
        dispatch({ type: "play_playlist", playlist: playlist });
        setError(false);
      } else {
        setError(true);
      }
    });
  };

  if (artistIds.length === 0) return null;

  return (
    <MediaPlayTrackWrapper>
      <div onClick={playTrack}>
        <button>
          <FontAwesomeIcon className="play-icon" icon={faPlay} />
        </button>
        Play Track{artistIds.length > 1 ? `s` : null}
      </div>
      {error && (
        <div className="noTrackMsg">
          <FontAwesomeIcon className="play-icon" icon={faSadTear} />
          <span>None of the tracks have playable media</span>
        </div>
      )}
    </MediaPlayTrackWrapper>
  );
};

JukeboxPlayArtist.propTypes = {
  artistIds: PropTypes.array,
};

export default JukeboxPlayArtist;
